<template>
  <div class="gga container">
    <div class="gga1 fl container-fluid" style="padding:1rem 0;">
      <marquee direction="left" style="height: 100%;width: 100%;display: flex;align-items: center;">
        <span>
          <span  v-for="item in list" :key="item.id">{{item.content}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </marquee>
    </div>
    <!--    <div class="ss">
        <form method="get" action="http://beijing.hyrzzx.com/plus/search.php" class="searchForm" name="searchForm">
            <input type="hidden" name="kwtype" value="0">
            <input type="text" name="q" placeholder="请输入关键字" id="edtSearch" size="12">
            <input type="submit" value="" name="btnPost" id="btnPost">
          </form>
        </div>-->
    <div class="clear"></div>
  </div>
</template>
<script>
import {getMovingNotices} from '@/api/home'

export default {
  data() {
    return {
      list:null
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList(){
      getMovingNotices().then((response)=>{
        this.list = response
      })
    }
  }
}
</script>